import { USER_AGENT } from "./version-Dl3bNTAd.js";
import { createOpenAI } from "@ai-sdk/openai";

//#region src/internal/agents/openai-provider.ts
const DEFAULT_OPENAI_MODEL = "gpt-5";
let configuredBaseUrl;
/**
* Configure the OpenAI base URL (CLI flag only, not environment variable).
* This must be called explicitly - it cannot be set via environment variables for security.
*/
function setOpenAIBaseUrl(baseUrl) {
	configuredBaseUrl = baseUrl;
}
/**
* Retrieve an OpenAI language model configured from environment variables and explicit config.
*
* Works with:
* - OpenAI API directly (default)
* - Generic OpenAI-compatible APIs via custom base URL (Vercel AI Gateway, proxies, etc.)
*
* Configuration:
* - OPENAI_API_KEY: API key for authentication (required)
* - OPENAI_MODEL: Model to use (default: "gpt-5") - env var OK
* - Base URL: Must be set via setOpenAIBaseUrl() - NOT from env vars (security risk)
*
* Note: Model name format depends on your provider:
* - Direct OpenAI: "gpt-4o", "gpt-4-turbo", etc.
* - Vercel AI Gateway: "openai/gpt-4o", "anthropic/claude-sonnet-4.5", etc.
* - Other providers: Check their documentation
*
* Azure-specific endpoint routing lives in the dedicated `azure-openai`
* provider so generic OpenAI-compatible endpoints keep predictable behavior.
*/
function getOpenAIModel(model) {
	const defaultModel = process.env.OPENAI_MODEL || DEFAULT_OPENAI_MODEL;
	const factory = createOpenAI({
		...configuredBaseUrl && { baseURL: configuredBaseUrl },
		headers: { "User-Agent": USER_AGENT }
	});
	return factory(model ?? defaultModel);
}

//#endregion
export { getOpenAIModel, setOpenAIBaseUrl };
//# sourceMappingURL=openai-provider-DK3FdwQ_.js.map